export default __webpack_public_path__ + "c4cde8beaf056bcdc4f9342d7e24f095.svg";